import { useEffect, useState } from 'react';

// iOS 앱 설치 홈 화면 추가(Add to Home Screen) 모달 훅
const useIosA2hs = () => {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    const ua = window.navigator.userAgent;
    const isIOS = /iphone|ipad|ipod/i.test(ua);
    // 홈화면에 추가후 실행중인지 아닌지 판별
    const isStandalone = (window.navigator as any).standalone === true || window.matchMedia('(display-mode: standalone)').matches;

    // 사파리 계열(크롬 iOS도 WebKit이라 share 경로는 동일) + 미설치 + 최초/주기적 노출
    const suppressedUntil = Number(localStorage.getItem('a2hs_suppress_until') || 0);
    const now = Date.now();

    if (isIOS && !isStandalone && now > suppressedUntil) {
      setShouldShow(true);
    }
  }, []);

  const suppress = (days = 7) => {
    const until = Date.now() + days * 24 * 60 * 60 * 1000;
    localStorage.setItem('a2hs_suppress_until', String(until));
    setShouldShow(false);
  };

  return { shouldShow, suppress, hide: () => localStorage.removeItem('a2hs_suppress_until') };
};

export default useIosA2hs;
